import React from "react";
import moment from "moment";
import StatCard from "../../atoms/StatCard";
import { formatCurrency } from "../../../utils/formatCurrency";
import StatsTable from "./StatsTable";

const Stats = ({ dataInmuebles = [], dataGastos = [], dataRentas = [], dataMantenimiento = [], loading }) => {
  const totalInmuebles = dataInmuebles.length;

  const totalGastos = dataGastos.reduce((acc, g) => acc + (Number(g.amount) || 0), 0);

  const rentedCount = dataInmuebles.filter((inm) => inm.isRented).length;
  const notRentedCount = dataInmuebles.length - rentedCount;

  const mortgagedCount = dataInmuebles.filter((inm) => inm.isMortgaged).length;
  const notMortgagedCount = dataInmuebles.length - mortgagedCount;

  const totalRentas = dataRentas.reduce((acc, r) => acc + (Number(r.total) || 0), 0);

  const totalMantenimiento = dataMantenimiento.reduce((acc, m) => acc + (Number(m.cost) || 0), 0);

  const hoy = moment().startOf("day");

  const getStartDate = (rent) => {
    if (!rent?.month) return null;
    const first = String(rent.month).split(" - ")[0]?.trim();
    return first ? moment(first, "YYYY-MM-DD", true) : null;
  };

  const rentasCobradas = dataRentas.filter((r) => r.status === true);

  const rentasAtrasadas = dataRentas.filter((r) => {
    if (r.status) return false;
    const start = getStartDate(r);
    return start?.isValid() && start.isSameOrBefore(hoy, "day");
  });

  const rentasProgramadas = dataRentas.filter((r) => {
    if (r.status) return false;
    const start = getStartDate(r);
    return start?.isValid() && start.isAfter(hoy, "day");
  });

  const sumTotal = (arr) => arr.reduce((acc, r) => acc + (Number(r.total) || 0), 0);

  const totalCobradas = sumTotal(rentasCobradas);
  const totalAtrasadas = sumTotal(rentasAtrasadas);
  const totalProgramadas = sumTotal(rentasProgramadas);

  return (
    <>
        <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-2">
        <StatCard title="Total de inmuebles" content={totalInmuebles} />
        <StatCard title="Total de gastos" content={formatCurrency(totalGastos)} />
        <StatCard title="Inmuebles rentados" content={`${rentedCount} / ${notRentedCount} no rentados`} />
        <StatCard title="Hipotecados" content={`${mortgagedCount} / ${notMortgagedCount} no hipotecados`} />
        <StatCard title="Total mantenimiento" content={formatCurrency(totalMantenimiento)} />
        <StatCard title="Total de rentas esperado" content={formatCurrency(totalRentas)} />
        <StatCard title="Rentas cobradas" content={`${rentasCobradas.length} | ${formatCurrency(totalCobradas)}`} />
        <StatCard title="Rentas atrasadas" content={`${rentasAtrasadas.length} | ${formatCurrency(totalAtrasadas)}`} />
        <StatCard title="Rentas programadas" content={`${rentasProgramadas.length} | ${formatCurrency(totalProgramadas)}`} />
        </div>
        <StatsTable
            loading={loading}
            dataInmuebles={dataInmuebles}
            dataGastos={dataGastos}
            dataRentas={dataRentas}
            dataMantenimiento={dataMantenimiento}
        />
      </>
  );
};

export default Stats;
